import React, { useEffect, useState, createRef, useRef, Fragment } from 'react';

import { IListProps } from '@fluentui/react';
import { Stack } from '@fluentui/react/lib/Stack';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { IStackTokens } from '@fluentui/react/lib/Stack';
import { apiServices } from '../../services/ApiServices';
import { Ref } from '@fluentui/react-northstar';
import { dialogTextStyle } from '../styles/common/Dialog.style';

import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { Icon } from '@fluentui/react/lib/Icon';
import moment from 'moment';
import { ChoiceGroup, IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import ChattingRecords from '../CommonElementPage/ChattingRecords';
import AccessibleDetailsList from '../AccessibleDetailsList';

import {
  getTheme,
  FontWeights,
  DatePicker,
  Dropdown,
  IDropdownOption,
  mergeStyles,
  IIconProps,
  IconButton,
  IButtonStyles,
} from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
let createdRef: any = createRef();

export interface IButtonExampleProps {
  disabled?: boolean;
  checked?: boolean;
}
const options: IChoiceGroupOption[] = [
  { key: '0', text: '不限' },
  { key: '1', text: '24小时内' },
  { key: '2', text: '48小时内' },
  { key: '3', text: '自定义' }
];

const stackTokens: Partial<IStackTokens> = { childrenGap: 20, padding: '24px' };
const theme = getTheme();
const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px'
  },
  fileIconCell: {
    textAlign: 'center',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden'
      }
    }
  },

  activeFeedbackBox: {
    display: 'flex'
  },
  activeFeedbackItem: {
    width: '20%',
    height: '34px',
    lineHeight: '34px',
    color: '#5B5FC7',
    cursor: 'pointer',
    fontWeight: 600,
    textAlign: 'center',
    border: 'solid 1px #5B5FC7'
  },
  FeedbackItem: {
    width: '20%',
    lineHeight: '34px',
    cursor: 'pointer',
    textAlign: 'center',
    height: '34px',
    border: 'solid 1px #ccc'
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '25px',
    maxWidth: '25px',
    borderRadius: '50%',
    marginRight: '10px'
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px'
  },
  selectionDetails: {
    marginBottom: '20px'
  },
  listButton: {
    fontWeight: '400',
    fontSize: '14px',
    background: '#FFFFFF',
    width: '96px',
    height: '32px',
    border: '1px solid #E1DFDD',
    borderRadius: '1px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  DatePicker: {
    '.ms-TextField-fieldGroup': {
      border: 'none'
    }
  },
  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overFoller: "scroll"
  },
  container: {
    display: 'flex',
    minHeight: '100%',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  screenContainer: {
    background: '#fff',
    display: 'flex',
    height: "100%",
    minHeight: '100%',
    width: '20%',
    minWidth: "300px",
    position: 'fixed',
    right: '0',
    boxSizing: 'border-box',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    overflowY: 'scroll',
  },
  dialogModal: {
    alignItems: 'flex-start',
  },
  header: {
    borderTop: `4px solid ${theme.palette.themePrimary}`,
    color: theme.palette.neutralPrimary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: FontWeights.semibold,
    padding: '5px',
    borderBottom: 'solid 1px #ccc'
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    height: "90%",
    padding: '0 24px 24px 24px',
    overflowY: 'scroll',
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 }
    },
    maxWidth: '100%',
    maxHeight: '100%',
    boxSizing: 'border-box'
  },
  foot: {
    borderTop: "1px solid #E0E0E0",
    display: 'flex',
    height: "64px",
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0 8px 0px 8px',
    minHeight: "64px",
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 }
    },

    boxSizing: 'border-box'
  },
  Chat: {
    flex: "1",
    overflow: 'scroll'
  }
});

const cancelIcon: IIconProps = { iconName: 'Cancel' };
export interface IDetailsListDocumentsExampleState {
  columns: IColumn[];
  items: IDocument[];
  selectionDetails: string;
  isModalSelection: boolean;
  false: boolean;
  announcedMessage?: string;
}

export interface activeItemCreator {
  accessToken: any;
  channelUserId: string;
  displayName: string;
  tokenExpireOn: string;
  userAvatar: string;
  userId: string;
}
export interface activeItem {
  comment: string;
  createAt: string;
  creator: activeItemCreator;
  csrUser: any;
  displayTicketId: string;
  fromChannel: string;
  id: string;
  lastModifiedBy: any;
  status: number;
  tenantId: string;
  toChannel: string;
  updateAt: string;
}

export interface IDocument {
  key: string;
  name: string;
  value: string;
  iconName: string;
  fileType: string;
  modifiedBy: string;
  dateModified: string;
  dateModifiedValue: number;
  fileSize: string;
  fileSizeRaw: number;
}

//筛选按钮
const onRenderPlaceholder = (): JSX.Element => {
  return (
    <div
      className="dropdownExample-placeholder"
      style={{ justifyItems: 'center', alignItems: 'center', display: 'felx' }}
    >
      <Icon style={{ marginRight: '8px' }} iconName={'QueryList'} aria-hidden="true" />
      <span className={dialogTextStyle}>筛选</span>
    </div>
  );
};

const exampleOptions: IDropdownOption[] = [
  { key: 0, text: '筛选', data: { icon: 'Memo' } },
];
const rootClass = mergeStyles({ selectors: { '> *': { marginBottom: 15 } } });
const rootBoxClass = mergeStyles({
  // maxWidth: 250,
  selectors: { '> *': { marginBottom: 15 } },
  position: 'absolute',
  right: '45px',
  top: '5px',
  display: 'flex'
});


const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};
let timer: NodeJS.Timeout;
let offset = 0;
let user: any;

if(typeof sessionStorage !== 'undefined') {
  user = sessionStorage.getItem('user');
}
const currentUserId = user && user != 'undefined' ? JSON.parse(user)?.userId : '';
export default function LogPage() {
  const messagesEnd = useRef<HTMLDivElement>(null);
  const [logListLimit, setLogListLimit] = useState(50);
  const [logListParameter, setLogListParameter] = useState({});
  const [activeItem, setActiveItem] = useState<activeItem>();
  const [logList, setLogList] = useState([]);
  const [isReset, setIsReset] = useState(true); //是否重置
  const [screenData, setScreenData] = useState({
    limit: logListLimit,
    offset: 0,
    userId: currentUserId,
    ticketId: '',
    feedBack: null,
    keyWord: '',
    filterType: '0',
    createAtStart: ''
  });

  //遮罩层 查看历史记录
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenScreen, setIsOpenScreen] = useState(false);
  useEffect(() => {
    getUserId()
    createdRef.current.addEventListener('scroll', ScrollDetailsList);
    window.addEventListener('scroll', ScrollDetailsList);
  }, []);

  const getUserId = async () => {
    let UserAgentStatusInfo = await apiServices.getUserAgentStatus();
    if (UserAgentStatusInfo) {
      let userId = UserAgentStatusInfo?.result.userId
      setLogListParameter(() => {
        getLogList({ limit: logListLimit, offset: 0, filterType: 0, userId: userId });
        return { limit: logListLimit, offset: 0, filterType: 0, userId: userId };
      });
    }

  }

  // 点击标头
  const _onColumnClick = (event: React.MouseEvent<HTMLElement>, column: IColumn) => {
    let isSortedDescending = column.isSortedDescending;
    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }
    // Sort the items.
    setLogList((s) => {
      let chars = column.fieldName!;
      let sortedItems;
      sortedItems = s
        .slice(0)
        .sort((a, b) => ((isSortedDescending ? a[chars] < b[chars] : a[chars] > b[chars]) ? 1 : -1));
      return sortedItems;
    });
    // setLogList(sortedItems);
    let columns2 = columns.map((col) => {
      col.isSorted = col.key === column.key;
      if (col.isSorted) {
        col.isSortedDescending = !col.isSortedDescending;
      }
      return col;
    });
    setColumns(columns2);
  };

  let columns1: IColumn[] = [
    {
      key: 'column7',
      name: '客户初次接入时间',
      fieldName: 'startTime',
      minWidth: 180,
      maxWidth: 200,
      isRowHeader: true,
      isResizable: true,
      onColumnClick: _onColumnClick,
      data: 'string',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <span>
            {' '}
            {item.startTime}
          </span>
        );
      }
    },
    {
      key: 'column1',
      name: '客户姓名',
      fieldName: 'ctrDisplayName',
      minWidth: 320,
      maxWidth: 350,
      isRowHeader: true,
      isResizable: true,
      // isSorted: true,
      isSortedDescending: false,
      onColumnClick: _onColumnClick,
      data: 'string',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <span>
            {' '}
            {item.ctrDisplayName}
          </span>
        );
      }
    },
    {
      key: 'column4',
      name: '工单编号',
      fieldName: 'displayTicketId',
      minWidth: 320,
      maxWidth: 350,
      isResizable: true,
      isSortedDescending: false,
      isCollapsible: true,
      isSorted: true,
      data: 'number',
      onColumnClick: _onColumnClick,
      onRender: (item: any) => {
        return <span className={dialogTextStyle}>{item.displayTicketId}</span>;
      }
    },
    {
      key: 'column2',
      name: '关闭时间',
      fieldName: 'updateAt',
      minWidth: 320,
      maxWidth: 350,
      isResizable: true,
      isSortedDescending: false,
      isCollapsible: true,
      isSorted: true,
      data: 'string',
      onColumnClick: _onColumnClick,
      onRender: (item: any) => {
        return <span className={dialogTextStyle}>{moment(item.updateAt).format('YYYY/MM/DD LT')}</span>;
      },
      isPadded: true
    },

    {
      key: 'column6',
      name: '操作',
      fieldName: 'fileSizeRaw',
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      isSortedDescending: false,
      isCollapsible: true,
      // isSorted: true,
      data: 'number',
      onRender: (item: any) => {
        return (
          <div className={classNames.fileIconImg}>
            {' '}
            <DefaultButton
              className={classNames.listButton}
              text="查看"
              onClick={() => {
                details(item);
              }}
            />{' '}
          </div>
        );
      }
    }
  ];
  const [columns, setColumns] = useState<IColumn[]>(columns1);

  // 滚动加载

  const ScrollDetailsList = () => {
    setIsReset((isReset) => {
      if (messagesEnd && messagesEnd.current) {
        const box = messagesEnd.current.getBoundingClientRect();
        // const cl = document.ch、
        if (box.bottom < window.innerHeight) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            offset = offset + 1;
            let data;
            if (isReset) {
              data = { limit: logListLimit, offset: offset * logListLimit, filterType: 0, userId: currentUserId };
            } else {
              setScreenData((screenData) => {
                data = JSON.parse(JSON.stringify(screenData));

                data.offset = offset * logListLimit;
                return data;
              });
            }
            getLogList(data, true);
          }, 1000);
        }
      }
      return isReset;
    });
  };

  //点击查看
  const details = (data: any) => {

    setActiveItem(data);

    // LoadHistoryMessages(true, data);
    setIsModalOpen(true);
  };
  //列表
  const getLogList = async (data?: any, isMore?: boolean) => {

    let res = data ? await apiServices.getLogList(data) : await apiServices.getLogList(logListParameter);
    res.result.forEach((item: any) => {
      item.ctrDisplayName = `${item.creator?.displayName || `游客     ${moment(item.createAt).format('M/D/LT')}`}`;
      item.startTime = `${item.fromUserExtend?.defaultName.replace('Visitor ', '')}`;
      if (item.feedBack && item.feedBack.satisfaction != -1) {
        item.FeedBackScore = item.feedBack.satisfaction;
      } else {
        item.FeedBackScore = '未评分';
      }

      item.curDisplayName = item.csrUser?.displayName;
    });
    let list: never[] = JSON.parse(JSON.stringify(res.result));
    isMore ? setLogList((s: never[]) => [...s, ...list]) : setLogList(list);

  };

  const _getKey = (item: any, index?: number) => {
    return item.key;
  };
  //日期选择器
  const [firstDayOfWeek, setFirstDayOfWeek] = React.useState(new Date());

  const dateChange = (date: Date | null | undefined) => {
    if (date) {
      setFirstDayOfWeek(date);
    }
    let data = { limit: logListLimit, offset: 0, filterType: '3', createAtStart: moment(date).format() };
    setScreenData((s) => {
      s.filterType = '3';
      s.createAtStart = moment(date).format();
      return s;
    });
    getLogList(data);
  };
  //筛选按钮

  const screenChange = async (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
    let data = { limit: logListLimit, offset: 0, filterType: index + '' };

    getLogList(data);
  };


  //筛选相关
  const [selectedKey, setSelectedKey] = React.useState<string | undefined>('0');

  const [activeFeedback, setActiveFeedback] = useState(0);



  const _PrimaryClicked = () => {
    setIsOpenScreen(false);
    setIsReset(false);
    let data = JSON.parse(JSON.stringify(screenData));
    for (let key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }
    getLogList(data);
    // setActiveData(item);
  };
  const _clearClicked = () => {
    setActiveFeedback(0);
    setFirstDayOfWeek(new Date());
    setIsOpenScreen(false);
    setIsReset(true);
    setSelectedKey('0');
    setScreenData({
      limit: logListLimit,
      offset: 0,
      userId: currentUserId,
      ticketId: '',
      feedBack: null,
      keyWord: '',
      filterType: '0',
      createAtStart: ''
    });
    activeFeedbackBox(0);
    getLogList();
  };
  const activeFeedbackBox = async (data: any) => {
    setActiveFeedback(data.key);
    setScreenData((s) => {
      let newData = JSON.parse(JSON.stringify(s));
      newData.feedBack = data.key;
      return newData;
    });
  };
  const screenDateChange = async (event: any, option: any, index?: number) => {
    let newData = JSON.parse(JSON.stringify(screenData));
    if (option.key !== '3') {
      delete newData.createAtStart;
    }
    setSelectedKey(option.key);
    newData.filterType = option.key;

    setScreenData(newData);
  };
  return (
    <Ref innerRef={createdRef}>
      <Stack
        style={{ display: 'felx', height: '100%', overflowY: 'scroll' }}
        data-is-focusable
      >
        {logList.length > 0 ? <AccessibleDetailsList
          id="personalLogPage-accessible-detailsList"
          component={DetailsList}
          items={logList}
          compact={false}
          columns={columns}
          selectionMode={SelectionMode.none}
          getKey={_getKey}
          enableUpdateAnimations={true}
          constrainMode={0}
          onShouldVirtualize={(props: IListProps) => false}
          setKey="none"
          layoutMode={DetailsListLayoutMode.fixedColumns}
          isHeaderVisible={true}
          onRenderCheckbox = {()=> {
            return (
              <Fragment/>
            );
          }}
        /> : <div style={{ textAlign: "center" }}>暂无数据</div>}

        {<div className={rootBoxClass}>
          <Dropdown
            placeholder="筛选"
            label=""
            ariaLabel="Custom dropdown example"
            onRenderPlaceholder={onRenderPlaceholder}

            styles={{
              dropdown: {
                width: 80,
                border: 'none',
                span: { border: 'none' },
                '.ms-Dropdown-caretDownWrapper': { display: 'none' }
              }
            }}
            options={exampleOptions}
            onClick={() => {
              setIsOpenScreen(true);
            }}
            onChange={screenChange}
          />


        </div>}
        {/* 滚动监听 */}
        <div ref={messagesEnd} style={{ width: '100%', height: '5px' }}>
          {/* 加载更多... */}
        </div>
        {
          isModalOpen ? <div
            key={'ChattingRecords'}
            style={{ position: "fixed", width: "100%", height: "100%", backgroundColor: "#fff", top: "0px", left: "0" }}
            className={classNames.dialogModal}
          >
            <div className={classNames.container}>
              <div className={classNames.header}>
                <IconButton
                  styles={iconButtonStyles}
                  iconProps={cancelIcon}
                  ariaLabel="Close popup modal"
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                />
              </div>
              <div className={classNames.body}>
                <p>工单号：{activeItem?.displayTicketId}</p>
                <p>工单记录：{activeItem?.comment}</p>
                <div className={classNames.Chat}>
                  <ChattingRecords isReverse={true} data={activeItem}></ChattingRecords>
                </div>
                <div style={{ cursor: 'pointer', color: "rgb(91, 95, 199)" }} onClick={() => {
                  setIsModalOpen(false);
                }}>
                  {' < 返回'}

                </div>
              </div>
            </div>


          </div> : ''
        }

        {
          isOpenScreen ? <div
            style={{ position: "fixed", width: "100%", height: "100%", backgroundColor: "rgba(128,128,128,0.8)", top: "0px", left: "0" }}
            className={classNames.dialogModal}
          >
            <div className={classNames.screenContainer}>
              <div style={{ flex: "1", boxSizing: "border-box" }}>
                <div className={classNames.header}>
                  <span style={{ fontWeight: 700, fontSize: '18px', marginLeft: "19px" }}>搜索</span>
                  <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={() => {
                      setIsOpenScreen(false);
                    }}
                  />
                </div>
                <Stack tokens={stackTokens}>
                  <SearchBox
                    placeholder="搜索工单号"
                    value={screenData.ticketId}
                    clearButtonProps={{ style: { display: 'none' } }}
                    onChange={(e: any) => {
                      setScreenData((s) => {
                        let newData = JSON.parse(JSON.stringify(s));
                        newData.ticketId = e.target?.value || '';
                        return newData;
                      });
                    }}
                    onBlur={(e: any) => {
                      setScreenData((s) => {
                        let newData = JSON.parse(JSON.stringify(s));
                        newData.ticketId = e.target?.value || '';
                        return newData;
                      });
                    }}
                  />
                  <SearchBox
                    placeholder="搜索关键字"
                    value={screenData.keyWord}
                    clearButtonProps={{ style: { display: 'none' } }}
                    onChange={(e: any) => {
                      setScreenData((s) => {
                        let newData = JSON.parse(JSON.stringify(s));
                        newData.keyWord = e.target?.value || '';
                        return newData;
                      });
                    }}
                    onBlur={(e: any) => {
                      setScreenData((s) => {
                        let newData = JSON.parse(JSON.stringify(s));
                        newData.keyWord = e.target?.value || '';
                        return newData;
                      });
                    }}
                    disableAnimation
                  />
                </Stack>
                <Stack tokens={stackTokens}>
                  <ChoiceGroup selectedKey={selectedKey} options={options} onChange={screenDateChange} label="时间范围" />
                  {selectedKey == '3' && (
                    <div className={rootClass}>
                      <DatePicker
                        className={classNames.DatePicker}
                        value={firstDayOfWeek}
                        placeholder="选择日期    "
                        ariaLabel="选择日期"
                        onSelectDate={dateChange}
                        styles={{}}
                      />
                    </div>
                  )}
                </Stack>
              </div>
              <Stack horizontal tokens={stackTokens} className={classNames.foot}>
                <a style={{ color: "#6264A7", marginLeft: "16px" }} onClick={_clearClicked}>清空</a>
                <div>
                  <DefaultButton style={{ marginRight: "8px", width: "80px", height: "32px" }} text="取消" onClick={() => { setIsOpenScreen(false); }} allowDisabledFocus />
                  <PrimaryButton style={{ marginRight: "8px", width: "80px", height: "32px" }} text="应用" onClick={_PrimaryClicked} allowDisabledFocus />
                </div>
              </Stack>

            </div>

          </div> : ''
        }

      </Stack>
    </Ref>
  );
}
